/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Draft_GeneratedInputs */

const en_ai_draft_generated = /** @type {(inputs: Ai_Draft_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Draft generated!`)
};

const es_ai_draft_generated = /** @type {(inputs: Ai_Draft_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Borrador IA generado!`)
};

const fr_ai_draft_generated = /** @type {(inputs: Ai_Draft_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brouillon IA généré !`)
};

const de_ai_draft_generated = /** @type {(inputs: Ai_Draft_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Entwurf generiert!`)
};

const ja_ai_draft_generated = /** @type {(inputs: Ai_Draft_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIの下書きが生成されました！`)
};

const zh_ai_draft_generated = /** @type {(inputs: Ai_Draft_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 草稿已生成！`)
};

const ar_ai_draft_generated = /** @type {(inputs: Ai_Draft_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم إنشاء مسودة الذكاء الاصطناعي!`)
};

const id_ai_draft_generated = /** @type {(inputs: Ai_Draft_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draf AI dibuat!`)
};

const it_ai_draft_generated = /** @type {(inputs: Ai_Draft_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bozza dell'IA generata!`)
};

const ru_ai_draft_generated = /** @type {(inputs: Ai_Draft_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Черновик ИИ сгенерирован!`)
};

const pt_ai_draft_generated = /** @type {(inputs: Ai_Draft_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rascunho de IA gerado!`)
};

const ko_ai_draft_generated = /** @type {(inputs: Ai_Draft_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 초안이 생성되었습니다!`)
};

/**
* | output |
* | --- |
* | "AI Draft generated!" |
*
* @param {Ai_Draft_GeneratedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ai_draft_generated = /** @type {((inputs?: Ai_Draft_GeneratedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Draft_GeneratedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ai_draft_generated(inputs)
	if (locale === "es") return es_ai_draft_generated(inputs)
	if (locale === "fr") return fr_ai_draft_generated(inputs)
	if (locale === "de") return de_ai_draft_generated(inputs)
	if (locale === "ja") return ja_ai_draft_generated(inputs)
	if (locale === "zh") return zh_ai_draft_generated(inputs)
	if (locale === "ar") return ar_ai_draft_generated(inputs)
	if (locale === "id") return id_ai_draft_generated(inputs)
	if (locale === "it") return it_ai_draft_generated(inputs)
	if (locale === "ru") return ru_ai_draft_generated(inputs)
	if (locale === "pt") return pt_ai_draft_generated(inputs)
	return ko_ai_draft_generated(inputs)
});